/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  UseMutationOptions,
  UseMutationResult,
  QueryClient,
} from "@tanstack/react-query"
import { mutationOptions, useMutation } from "@tanstack/react-query"

import fetch from "~/backend/axiosClient"
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
  ResponseConfig,
} from "~/backend/axiosClient"

import type {
  DeleteViewMutationResponse,
  DeleteViewPathParams,
} from "../types/DeleteView.ts"

export const deleteViewMutationKey = () =>
  [{ url: "/v1/view/delete-view/:id" }] as const

export type DeleteViewMutationKey = ReturnType<typeof deleteViewMutationKey>

/**
 * @summary Delete a view
 * {@link /v1/view/delete-view/:id}
 */
export async function deleteView(
  id: DeleteViewPathParams["id"],
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const res = await request<
    DeleteViewMutationResponse,
    ResponseErrorConfig<Error>,
    unknown
  >({ method: "DELETE", url: `/v1/view/delete-view/${id}`, ...requestConfig })
  return res
}

export function deleteViewMutationOptions<TContext = unknown>(
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const mutationKey = deleteViewMutationKey()
  return mutationOptions<
    ResponseConfig<DeleteViewMutationResponse>,
    ResponseErrorConfig<Error>,
    { id: DeleteViewPathParams["id"] },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ id }) => {
      return deleteView(id, config)
    },
  })
}

/**
 * @summary Delete a view
 * {@link /v1/view/delete-view/:id}
 */
export function useDeleteView<TContext>(
  options: {
    mutation?: UseMutationOptions<
      ResponseConfig<DeleteViewMutationResponse>,
      ResponseErrorConfig<Error>,
      { id: DeleteViewPathParams["id"] },
      TContext
    > & { client?: QueryClient }
    client?: Partial<RequestConfig> & { client?: Client }
  } = {}
) {
  const { mutation = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...mutationOptions } = mutation
  const mutationKey = mutationOptions.mutationKey ?? deleteViewMutationKey()

  const baseOptions = deleteViewMutationOptions(config) as UseMutationOptions<
    ResponseConfig<DeleteViewMutationResponse>,
    ResponseErrorConfig<Error>,
    { id: DeleteViewPathParams["id"] },
    TContext
  >

  return useMutation<
    ResponseConfig<DeleteViewMutationResponse>,
    ResponseErrorConfig<Error>,
    { id: DeleteViewPathParams["id"] },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient
  ) as UseMutationResult<
    ResponseConfig<DeleteViewMutationResponse>,
    ResponseErrorConfig<Error>,
    { id: DeleteViewPathParams["id"] },
    TContext
  >
}
